import { CardTemplate } from '~/editor/v2/cards/templates/types';
import { sanitizeBodyForSave, stripHtml } from '~/lib/sanitization';
import textCardImage from '~/assets/editor/cards4-text-card.jpg';
import {
  cardSubtitleField,
  plainTextCodec
} from '~/editor/v2/cards/templates/textFields';

export const textCardTemplate: CardTemplate = {
  type: 'text',
  label: 'Text Card',
  cardImage: textCardImage,

  fields: [
    // The kicker first: the card shows it above its title.
    cardSubtitleField,
    {
      type: 'input',
      name: 'title',
      label: 'Title',
      maxLength: 120,
      placeholder: 'Enter title',
      ...plainTextCodec,
      defaultValue: 'Lorem Ipsum'
    },
    {
      type: 'textarea',
      name: 'body',
      label: 'Description',
      maxLength: 1200,
      placeholder: 'Enter description',
      sanitizer: sanitizeBodyForSave,
      deserializer: stripHtml,
      defaultValue:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sollicitudin sem sed fermentum consequat.'
    }
  ],

  validation: { type: 'atLeastOne', fields: ['title', 'body'] },
  createModalTitle: 'New Text Card',
  editModalTitle: 'Edit Text Card'
};
